<div>
  <form class="">
    <div class="d-flex justify-content-center ">
      <div class="card w-card mt-md-5 mt-3 shadow p-3 mb-5 bg-body rounded">

        <div class="d-flex justify-content-center">
          <div class="col-6">
            <img src="https://crabslogistica.ar/IMG/icons/crabs-logo.png" class="img-fluid" alt="...">
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div class="card-body">
            <div class="form-floating mb-3">
              <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com" (keydown.enter)="iniciarSesion(email.value ,password.value)" #email>
              <label for="floatingInput">Usuario</label>
            </div>
            <div class="form-floating mb-3">
              <input type="password" class="form-control" id="floatingPassword" placeholder="Password" (keydown.enter)="iniciarSesion(email.value ,password.value)" #password>
              <label for="floatingPassword" >Contraseña</label>
            </div>
            <!-- <div class="mb-3 form-check">
              <input type="checkbox" class="form-check-input" id="exampleCheck1">
              <label class="form-check-label" for="exampleCheck1">Recordar</label>
            </div> -->
            <div *ngIf="alerta===true" class="alert alert-danger" role="alert">
              Usuario o Contraseña invalida
            </div>
            <div class="form-floating text-center">
              <button type="submit" class="btn btn-outline-primary" (click)="iniciarSesion(email.value ,password.value)">Ingresar</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </form>
</div>
<!--<div class="bg-white">
  <form>
    <img class="mb-4" src="../assets/brand/bootstrap-logo.svg" alt="" width="72" height="57">
    <h1 class="h3 mb-3 fw-normal">Please sign in</h1>

    <div class="form-floating">
      <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com">
      <label for="floatingInput">Email address</label>
    </div>
    <div class="form-floating">
      <input type="password" class="form-control" id="floatingPassword" placeholder="Password">
      <label for="floatingPassword">Password</label>
    </div>

    <div class="checkbox mb-3">
      <label>
        <input type="checkbox" value="remember-me"> Remember me
      </label>
    </div>
    <button class="w-100 btn btn-lg btn-primary" type="submit">Sign in</button>
    <p class="mt-5 mb-3 text-muted">&copy; 2017–2021</p>
  </form>
</div>-->
